import { certifikatPredelavaService } from '../services/certifikatPredelava.service';
import  Vue  from 'vue';

const state = {
    certifikatPredelava: [],
    sezona:null,
    predelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,predelovalecid,makeEditable}) {
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPredelovalecID', predelovalecid)
      return certifikatPredelavaService.load(sezona,predelovalecid)
            .then(
                certifikatPredelava => {
                  commit('load', certifikatPredelava);
                  if(makeEditable)
                  commit('makeEditable') 
                  return certifikatPredelava;                   
                } 
                
            );
    },
    vrniPoId({ dispatch,commit },{id}) {
        dispatch('alert/clear', "",{ root: true });
      commit('load');
      //  commit('setSezona', sezona)
     return  certifikatPredelavaService.vrniPoId(id)
          .then(
              certifikat => commit('load', certifikat)
              //,
              //error => commit('getLoggedInFailure', error)
          );
  },
    loadVse({ dispatch,commit },{sezona}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  certifikatPredelavaService.loadAll(sezona)
            .then(
                certifikatPredelava => commit('load', certifikatPredelava)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
    saveCert({ dispatch, commit },{certifikat}){

        console.log(certifikat);
        certifikatPredelavaService.save(certifikat)
               .then(
                cert => {
                    Vue.set(certifikat,'saved',true);
                    //Vue.set(certifikat,'jeaktivna',1);
                    // Vue.set(state.certifikat,certifikat.veljaven);
                      Vue.set(certifikat,'id',cert.id);

                    //commit("update",item);
                    
                },
                error => {
                    console.log(error);
                    Vue.set(certifikat,'saved',false)
                    //commit("update",item);
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
                );

     },
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.certifikatPredelava.sezona;
        let predelovalecid=this.state.certifikatPredelava.predelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.certifikatPredelava.certifikatPredelava.forEach(item=>{
            item.sezona=sezona;
            item.predelovalecid=predelovalecid;
            console.log(item);
            if(item.jeaktivna){
              certifikatPredelavaService.save(item)
               .then(
                certifikatPredelava => {
                    Vue.set(item,'saved',true);
                     Vue.set(item,'jeaktivna',1);
                      Vue.set(item,'id',certifikatPredelava.id);
                    //commit("update",item);
                    
                },
                error => {
                    console.log(error);
                    Vue.set(item,'saved',false)
                    //commit("update",item);
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
            }
            else
             certifikatPredelavaService.remove(item).then(
                certifikatPredelava => {
                 Vue.set(item,'saved',true);
                                      
                },
                error => {
                    console.log(error);
              Vue.set(item,'saved',false);
                  
                    dispatch('alert/error', "Brisanje ni uspelo", { root: true });
                });
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          });
       
        
    }
};

const mutations = {
  
    load(state, certifikat) {
        if(certifikat&&Array.isArray(certifikat))
   state.certifikatPredelava=certifikat.map(k=>{
       k["datumizdaje"]=kendo.parseDate(k["datumizdaje"]) 
       k["datumveljavnosti"]=kendo.parseDate(k["datumveljavnosti"]) 
     
       return k;
   }

       );
       else if(certifikat){
       state.certifikatPredelava=certifikat;   
       state.certifikatPredelava.datumveljavnosti=kendo.toString(kendo.parseDate(state.certifikatPredelava.datumveljavnosti),'d');//kendo.parseDate(state.certifikat.datumveljavnosti); 
       state.certifikatPredelava.datumizdaje=kendo.toString(kendo.parseDate(state.certifikatPredelava.datumizdaje),'d');
       }
},
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.certifikatPredelava.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.certifikatPredelava.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.certifikatPredelava.length;i++){
            let dateStr=state.certifikatPredelava[i].datumizdaje;
            if(dateStr)
                state.certifikatPredelava[i].datumizdaje=new Date(dateStr);
            else
                state.certifikatPredelava[i].datumizdaje=new Date( );

            let dateVeljavnostStr=state.certifikatPredelava[i].datumveljavnosti;
            if(dateVeljavnostStr)
                state.certifikatPredelava[i].datumveljavnosti=new Date(dateVeljavnostStr);
            else
                state.certifikatPredelava[i].datumveljavnosti=new Date( ); //zadnji dan v naslednjem letu

            let updated = Object.assign({}, state.certifikatPredelava[i], { inEdit: true });
            state.certifikatPredelava.splice(i,1,updated);
        }
        

    },
    setPredelovalecID(state, item) {
        state.predelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.certifikatPredelava.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.certifikatPredelava.splice(index,1,updated);
            } else {
                let id = 1;
                state.certifikatPredelava.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.certifikatPredelava.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.certifikatPredelava.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.certifikatPredelava);
                state.certifikatPredelava.splice(index, 1);
        
        //    return data[index];
        //state.certifikatPredelava=data;

    },
    replace(state, certifikatPredelava) {
        state.certifikatPredelava = certifikatPredelava;
    }
   
};

export const certifikatPredelava = {
    namespaced: true,
    state,
    actions,
    mutations
};
